<template>
  <TableGradient
      icon-name="range"
      title="Ranges"
      route-new="vns.ranges.create"
      :text-empty="$t('vns.ranges.listagem.table.empty')"
      :text-new="$t('vns.ranges.listagem.novo')"
      :fields="fields"
      :items="ranges"
      :loading="isLoading"
      :paginator="paginator"
      @list="evt => $store.dispatch('ranges/listAll', evt)"
      :fields-filter="filter">
    <template v-slot:cell(id)="linha">
      <router-link :id="'link-edit-' + linha.index" :to="{ name: 'vns.ranges.edit', params: { id: linha.item.id }}"
                   class="font-weight-bold">
        {{ $t('vns.ranges.listagem.table.editar') }}
      </router-link>
    </template>
    <template v-slot:cell(background_color)="linha">
      <span class="badge"
            :style="'background-color: ' + linha.item.background_color + ';color: ' + linha.item.background_color + ';'">
          {{ $t('vns.ranges.listagem.table.fundo') }}
      </span>
    </template>
    <template v-slot:cell(font_color)="linha">
      <span class="badge"
            :style="'background-color: ' + linha.item.font_color + ';color: ' + linha.item.font_color + ';'">
          {{ $t('vns.ranges.listagem.table.letra') }}
      </span>
    </template>
  </TableGradient>
</template>

<script>
import TableGradient from "@/templates/TableGradient";
import {mapActions, mapGetters} from 'vuex'

export default {
  name: "Index",
  components: {TableGradient},
  computed: {
    ...mapGetters({
      store_isLoading: 'ranges/isLoading',
      ranges: 'ranges/all',
      paginator: 'ranges/pagination',
    }),
    isLoading() {
      return !(this.mounted && this.store_isLoading === false)
    }
  },
  data() {
    return {
      mounted: false,
      fields: [
        {key: 'user_id', thClass: 'd-none', tdClass: 'd-none'},
        {key: 'company_id', thClass: 'd-none', tdClass: 'd-none'},
        {key: 'start_value', label: this.$t('vns.ranges.listagem.table.valor_inicial'), sortable: true},
        {key: 'end_value', label: this.$t('vns.ranges.listagem.table.valor_final'), sortable: true},
        {key: 'background_color', label: this.$t('vns.ranges.listagem.table.fundo')},
        {key: 'font_color', label: this.$t('vns.ranges.listagem.table.letra')},
        {key: 'id', label: this.$t('vns.ranges.listagem.table.editar')},
        {key: 'fa_icon', thClass: 'd-none', tdClass: 'd-none'},
        {key: 'created_at', thClass: 'd-none', tdClass: 'd-none'},
        {key: 'updated_at', thClass: 'd-none', tdClass: 'd-none'},
      ],
      filter: [
        {key: 'start_value', label: this.$t('vns.ranges.listagem.table.valor_inicial')},
        {key: 'end_value', label: this.$t('vns.ranges.listagem.table.valor_final')},
      ],
    }
  },
  methods: {
    ...mapActions([
      'ranges/listAll'
    ])
  },
  mounted() {
    this['ranges/listAll'](this.paginator)
    this.mounted = true
  }
}
</script>

<style lang="scss" scoped>
</style>
